import React from "react";

export const setRecordingContext = React.createContext();
export const getRecordingContext = React.createContext();
